import { hapticFeedbackImpactOccurred, hapticFeedbackSelectionChanged } from '@telegram-apps/sdk';

/*
 * Отклик вибрацией Telegram.
 *
 * Вне Telegram SDK бросает исключение даже из isAvailable(): кнопка
 * обязана сработать и без вибрации, поэтому ошибка гасится здесь.
 */

/** Нажатие кнопки действия: крутка, открытие сведений. */
export function hapticTap(): void {
  try {
    if (hapticFeedbackImpactOccurred.isAvailable()) hapticFeedbackImpactOccurred('light');
  } catch {
    // Нет Telegram — нет вибрации.
  }
}

/** Смена выбора: вкладка, баннер. */
export function hapticSelect(): void {
  try {
    if (hapticFeedbackSelectionChanged.isAvailable()) hapticFeedbackSelectionChanged();
  } catch {
    // Нет Telegram — нет вибрации.
  }
}
